import React from "react";
import { PhoneIcon } from "../../assets/icons/PhoneIcon";
import { WhatsappIcon } from "../../assets/icons/WhatsappIcon";
import { MailIcon } from "../../assets/icons/MailIcon";
import { HoraireIcon } from "../../assets/icons/HoraireIcon";
import "./index.scss"; // Import the styles
import img from "../../assets/images/contactMap.png"; // Import the image
export const ContactMap = () => {
  return (
    <div className="contactMap mt-5">
      <div className="contactMap-container d-flex align-items-center">
        <div className="row ms-0   gx-0 w-100 align-items-center">
          <div className="col-12 col-md-6 mx-auto ">
            <p className="contactMap-title mb-3 mb-md-5">
              Prenez contact avec nous
            </p>

            <div className="d-flex flex-wrap align-items-center contactMap-liste">
              <PhoneIcon />
              01 71 36 24 89
            </div>
            <div className="d-flex flex-wrap align-items-center contactMap-liste">
              <WhatsappIcon />
              WhatsApp
            </div>
            <div className="d-flex flex-wrap align-items-center  contactMap-liste">
              <MailIcon />
              contact@habitat-idf.fr
            </div>
            <div className="d-flex flex-wrap align-items-center contactMap-liste">
              <HoraireIcon />
              Lundi au Vendredi : 9h – 18h
            </div>
          </div>
          <div className="col-12 col-md-6 mx-auto d-flex justify-content-center">
            <img
              src={img}
              alt="Bento Habitat"
              className="img-fluid w-100 d-none d-md-block"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
